import React from 'react';
import { Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Layout } from 'features/common/components/Layout';
import { LoadRateOption, RatesList } from 'features/stats/components/RatesList';

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		marginTop: theme.spacing(1),
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'row',
		gap: theme.spacing(2),
	},
}));

function Rates(): JSX.Element {
	const classes = useStyles();

	return (
		<Layout>
			<div>
				<Container component="main" maxWidth="md" className={classes.container}>
					<RatesList />
					<RatesList loadRateOption={LoadRateOption.EUR} />
				</Container>
			</div>
		</Layout>
	);
}

export default Rates;
